module.exports = __webpack_public_path__ + "img/FindInPageOutlined.0f0a6093.svg";